import { Modal } from "@modernatx/ui-kit-react";
import React, { useEffect, useRef, useState } from "react";

import { SchedulePayModalContent } from "@/components/Payments/AutoPayModal/SchedulePayModalContent";
import { PaymentMethod, SchedulePayTypes } from "@/types/PaymentMethod";

export interface SchedulePayModalProps {
  modalType: SchedulePayTypes;
  isVisible: boolean;
  setVisible: (visible: boolean) => void;
  invoiceId?: string | string[];
}

export const SchedulePayModal: React.FC<SchedulePayModalProps> = ({
  modalType,
  isVisible,
  setVisible,
  invoiceId
}) => {
  const modalTitle = Array.isArray(invoiceId)
    ? "Schedule payments"
    : "Schedule payment";
  const modalButtons = [
    { label: "Cancel", onClick: () => setVisible(false) },
    { label: "Schedule", onClick: () => handleConfirmClick() }
  ];
  const [selectedPayment, setSelectedPayment] = useState<
    string | PaymentMethod | undefined
  >();

  const [showAddPaymentMethod, setShowAddPaymentMethod] = useState<boolean>(
    selectedPayment === "add-new"
  );

  const paymentFormSubmitRef = useRef<
    (() => Promise<PaymentMethod | undefined>) | undefined
  >(undefined);

  const handleConfirmClick = async () => {
    if (showAddPaymentMethod) {
      const newPaymentMethod = await paymentFormSubmitRef.current?.();
      if (newPaymentMethod) {
        setSelectedPayment(newPaymentMethod);
        setVisible(false);
      }
    }
  };

  useEffect(() => {
    setShowAddPaymentMethod(selectedPayment === "add-new");
  }, [selectedPayment]);

  return (
    <Modal
      title={modalTitle}
      isOpen={isVisible}
      onDismiss={() => setVisible(false)}
      buttons={modalButtons}
      size="sm"
    >
      <SchedulePayModalContent
        modalType={modalType}
        invoiceId={invoiceId}
        showAddPaymentMethod={showAddPaymentMethod}
        paymentFormSubmitRef={paymentFormSubmitRef}
        selectedPayment={selectedPayment}
        setSelectedPayment={setSelectedPayment}
      />
    </Modal>
  );
};
